<template>
  <div>
    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :doneFunction="doneFunction"
               tableApi="admin/order/getHuituoOrder"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="mobile">
          <Input type="text" v-model="searchData.mobile" placeholder="手机号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="user_name">
          <Input type="text" v-model="searchData.user_name" placeholder="姓名" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="car_number">
          <Input type="text" v-model="searchData.car_number" placeholder="车牌号" class="lx-search-item"></Input>
        </FormItem>

        <FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="datetimerange" @on-change="timeChange" placeholder="下单时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
         <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
        <FormItem class="stats-form-item">
          <Row>
            <Col span="24">
              <Alert type="info" show-icon>
                订单数：{{ countData.order_num }}，升数合计：{{ countData.number_sum }}，总金额合计：{{ countData.cost_sum }}
              </Alert>
            </Col>
          </Row>
        </FormItem>
      </template>

    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'

  export default {
    name: "lists",
    components:{pageTable},
    data() {
      return {
        searchData: {
          mobile: '',
          nick_name:'',
          car_number:'',
          create_time:'',
          gas_name:'',
          company_id:'',
          export_type:'ty',
          user_name:'',
        },
        tableColumn: [
          {title:'ID',key:'an_id',align:'center'},
          {title:'车牌号',key:'carId',align:'center'},
          {title:'油站',key:'happenPlace',align:'center'},
          {title:'数量(升)',key:'number',align:'center'},
          {title:'单价',key:'unitPrice',align:'center'},
          {title:'金额',key:'cost',align:'center'},
          {title:'油品',key:'oilType',align:'center'},
          {title:'下单时间',key:'happenTime',align:'center',width:170},
        ],
        tableData: [],
        countData:{
          order_num: 0,
          number_sum: 0,
          cost_sum: 0,
        },
      }
    },
    methods: {
      doneFunction(res){
        this.countData = {
          order_num: (res.extra && res.extra.order_num) || 0,
          number_sum: (res.extra && res.extra.number_sum) || 0,
          cost_sum: (res.extra && res.extra.cost_sum) || 0,
        }
      },
      exportData(){
        this.$commonFun.postProxy('admin/order/export',this.searchData).then((res)=>{
          this.$commonFun.dealApiResult(res,()=>{
            let worksheet = XLSX.utils.aoa_to_sheet(res.data)
            let workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
            XLSX.writeFile(workbook,`安能订单.xlsx`)
          })
        })
      },
      timeChange(time) {
        console.log(time)
        if(time[1].slice(-8)==='00:00:00'){
          time[1] = time[1].slice(0,-8) + '23:59:59'
          this.searchData.create_time = time
        }
      },
    },
    mounted() {

    },
  }
</script>

<style scoped>

.stats-form-item {
  display: block;
  width: 100%;
}

</style>
